import Express from "@Meridian-Developers/meridian-ui/middleware_controller";
// import { toast } from "react-toastify";
// import T2 from "../ui/Helpers/T2";
import CustomerHelper from "./CustomerHelper";

class ConnectAccountHelper {
    async verify(storage) {
        if (this.validateAllFields(storage)) {
            const validationFieldsInput = this.createFieldMap(storage);

            if (validationFieldsInput.serviceAddressPostal.length == 4) {
                // We can assume that the user isn't using their postal code to register.
                validationFieldsInput.idNumber =
                    validationFieldsInput.serviceAddressPostal;
                delete validationFieldsInput.serviceAddressPostal;

                if (validationFieldsInput.lastName == null) {
                    // This is a Business Registration
                    validationFieldsInput.idTypeCd = "EIN";
                } else {
                    // This is a Residential Registration.
                    validationFieldsInput.idTypeCd = "SSN";
                }
            }

            if (
                validationFieldsInput.firstName ||
                validationFieldsInput.lastName
            ) {
                const firstName = validationFieldsInput.firstName;
                const lastName = validationFieldsInput.lastName;
                validationFieldsInput.customerName = lastName
                    ? lastName.trim() + "," + firstName.trim()
                    : firstName.trim();
                delete validationFieldsInput.firstName;
                delete validationFieldsInput.lastName;
            }

            validationFieldsInput.verificationMode = true;

            let linkVerification = await Express.callPublic(
                "CMMCUESRegistrationService",
                validationFieldsInput
            );

            try {
                if (
                    !linkVerification.customerId &&
                    validationFieldsInput.customerName.includes("LLC")
                ) {
                    let retryData = { ...validationFieldsInput };
                    retryData.customerName = retryData.customerName.replace(
                        "LLC",
                        ""
                    );

                    linkVerification = await Express.callPublic(
                        "CMMCUESRegistrationService",
                        retryData
                    );
                }
            } catch (e) {
                console.log(e);
            }

            try {
                if (linkVerification.customerId) {
                    return linkVerification;
                } else {
                    // toast.error(
                    //     <T2 id="58">
                    //         No customer found for that account. Please try
                    //         again.
                    //     </T2>
                    // );
                    return { error: 58 };
                }
            } catch (e) {
                console.log(e);
                // toast.error(
                //     <T2 id="59">
                //         There was an issue durring linking. Please try again.
                //     </T2>
                // );
                return { error: 59 };
            }
        } else {
            // toast.error(
            //     <T2 id="60">One or more required fields are invalid.</T2>
            // );
            return { error: 60 };
        }
    }

    async link(registration, loadingCallback, finishedCallback) {
        const { customerId, phone, emailAddress } = registration;

        const accountList = [];

        const listAccountQueryInput = {
            inputList: [{ businessObjectDataArea: { perId: customerId } }],
        };

        const acctList = await Express.callAsync(
            "CMMCUESListAccountQrySvc",
            listAccountQueryInput
        );

        try {
            await new Promise(async (resolve) => {
                try {
                    if (acctList.outputList.accounts.length <= 0) {
                        resolve("done");
                        return;
                    }
                } catch (e) {
                    console.log(e);
                    resolve("done");
                    return;
                }

                if (acctList.outputList.accounts.length > 0) {
                    for (
                        let i = 0;
                        i < acctList.outputList.accounts.length;
                        i++
                    ) {
                        if (loadingCallback) {
                            loadingCallback({
                                loadingMessage:
                                    "Retrieving account " +
                                    (i + 1) +
                                    " of " +
                                    acctList.outputList.accounts.length,
                            });
                        }

                        const acct = acctList.outputList.accounts[i];

                        const ccbData = {
                            accounts: [
                                {
                                    accountId: acct.accountId,
                                    personId: customerId,
                                },
                            ],
                        };

                        const acctInfo = await Express.callAsync(
                            "CMMCUESAccountInfoQrySvc",
                            ccbData
                        );

                        try {
                            accountList.push({
                                accountId: acct.accountId,
                                acctInfo: acctInfo.accountInfo,
                                address: acctInfo.accountInfo.serviceAddress,
                            });
                        } catch (e) {}
                    }
                } else if (acctList.outputList.accounts.accountId) {
                    const ccbData = {
                        accounts: [
                            {
                                accountId:
                                    acctList.outputList.accounts.accountId,
                                personId: customerId,
                            },
                        ],
                    };

                    const acctInfo = await Express.callAsync(
                        "CMMCUESAccountInfoQrySvc",
                        ccbData
                    );
                    accountList.push({
                        accountId: acctList.outputList.accounts.accountId,
                        acctInfo: acctInfo.accountInfo,
                    });
                }

                resolve("done");
            });

            if (accountList.length > 0) {
                this.connectAccount(
                    { ...registration, accountList },
                    (results) => {
                        if (finishedCallback) {
                            finishedCallback(results);
                        }
                    }
                );
            } else {
                // toast.error(
                //     <T2 id="61">
                //         customer found, but no accounts with active service
                //     </T2>
                // );
                if (finishedCallback) {
                    finishedCallback({ error: 61 });
                }

                return { error: 61 };
            }
        } catch (e) {
            console.log(e);
            // toast.error(
            //     <T2 id="62">
            //         There was an issue durring linking. Please try again.
            //     </T2>
            // );
            // return { error: true };

            if (finishedCallback) {
                finishedCallback({ error: 62 });
            }

            return { error: 62 };
        }
    }

    async connectAccount(linkInput, callback) {
        console.log("linkInput", linkInput);

        const user = await CustomerHelper.fetchUser();

        Express.call(
            "connect-account",
            { user, linkInput, sessionId: Express.getSessionId() },
            (results) => {
                window.sessionStorage.setItem("sessionId", results);
                window.sessionStorage.setItem("isLinked", true);
                if (callback) {
                    callback("done");
                }
            }
        );
    }

    createFieldMap(inputField) {
        const results = {};
        const keyList = Object.keys(inputField);

        for (let i = 0; i < keyList.length; i++) {
            const key = keyList[i];
            if (inputField[key].value && inputField[key].value != "") {
                results[key] = inputField[key].value;
            }
        }

        return results;
    }

    validateAllFields(storage) {
        const keyList = Object.keys(storage);

        let valid = true;

        for (let i = 0; i < keyList.length; i++) {
            const key = keyList[i];
            const connectItem = storage[key];
            if (!connectItem.valid) {
                valid = false;
            }
        }
        return valid;
    }
}

export default new ConnectAccountHelper();
